export default __webpack_public_path__ + "static/media/post-suvinil4.3e050f41.png";